module.exports = __webpack_public_path__ + "img/invoicing.22647cdb.svg";